import Tracking from 'tracking/tracking-controller.ts';

const init = () => {
    Tracking.send('PAGE_VIEW_LOGIN_PAGE', {
        url: window.location.href,
    });
};

init();
